// extracted by mini-css-extract-plugin
export default {"showCard":"CustomRecommendationTwo_showCard__DeAyZ","editStyle":"CustomRecommendationTwo_editStyle__mKX2K","font20":"CustomRecommendationTwo_font20__3+Go8"};